module.exports = __webpack_public_path__ + "static/media/SIGEONLY.ee8039bd.png";